import { useTranslation } from "react-i18next";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useLocale } from "@/hooks/useLocale";
import { LOCALE_LABELS, type SupportedLocale } from "@/i18n";

export default function Preferences() {
  const { t } = useTranslation("settings");
  const { current, available, setLocale } = useLocale();

  return (
    <div className="min-h-screen bg-background pb-24 mx-auto w-full max-w-4xl">
      <div className="px-6 pt-8 pb-6">
        <h1 className="text-2xl font-bold text-foreground">{t("page.preferences")}</h1>
        <p className="text-muted-foreground">{t("preferences.subtitle")}</p>
      </div>

      <div className="px-6">
        <div className="bg-card rounded-xl border border-border p-6">
          <div className="max-w-sm space-y-2">
            <Label htmlFor="language">{t("preferences.languageLabel")}</Label>
            <Select value={current} onValueChange={(value) => void setLocale(value as SupportedLocale)}>
              <SelectTrigger id="language" aria-label={t("preferences.languageLabel")}>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {available.map((locale) => (
                  <SelectItem key={locale} value={locale}>
                    <span className="flex items-center gap-2">
                      <span aria-hidden="true">{LOCALE_LABELS[locale].flag}</span>
                      <span>{LOCALE_LABELS[locale].native}</span>
                    </span>
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <p className="text-sm text-muted-foreground">{t("preferences.languageHint")}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
